// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 980) return "js/sh-" + __webpack_require__.h() + ".css";
	// return url for filenames based on template
	return "css/" + "Home" + "-" + "1a6158bdeeec28e0ad24" + ".css";
};